document.querySelectorAll('[data-team-slider]').forEach((slider) => {
  const track = slider.querySelector('[data-team-track]');
  const slides = Array.from(slider.querySelectorAll('[data-team-slide]'));
  const prev = slider.querySelector('[data-team-prev]');
  const next = slider.querySelector('[data-team-next]');
  const count = parseInt(slider.dataset.teamCount, 10) || slides.length;

  if (count < 2 || !track || !prev || !next) return;

  let current = 0;

  const getVisibleCount = () => {
    const value = parseInt(
      window.getComputedStyle(slider).getPropertyValue('--team-visible'),
      10,
    );

    return Number.isFinite(value) && value > 0 ? value : 1;
  };

  const update = () => {
    const visible = getVisibleCount();
    const maxIndex = Math.max(0, count - visible);
    const hasOverflow = maxIndex > 0;

    current = Math.min(current, maxIndex);
    slider.style.setProperty('--team-index', current);
    slider.classList.toggle('has-overflow', hasOverflow);

    prev.disabled = current === 0;
    next.disabled = current >= maxIndex;

    slides.forEach((slide, index) => {
      const isVisible = index >= current && index < current + visible;
      slide.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
    });
  };

  prev.addEventListener('click', () => {
    current -= 1;
    update();
  });

  next.addEventListener('click', () => {
    current += 1;
    update();
  });

  window.addEventListener('resize', update);
  update();
});
